/**
 * Created by or_p on 3/28/2017.
 */
import { StorageLRU, asyncify } from 'storage-lru';
import { store } from 'App/store';
import $ from 'jquery';
import _ from 'lodash';
import async from 'async';
import {wrapAjax} from 'MyAccount/ViewDesigns/helpers/preferencesHelper';

function updateStoreData(storeData) {
  return {
    ...storeData,
    ..._.pick(store.getState(), ['user', 'templateTagSet', 'accountPage', 'general']),
  };
}

const getInitialStoreInternal = (query, callback) => {
  const {templateList} = store.getState().templates;
  const publicTemplate = templateList[query.id];
  return $.ajax({
    url: '/application/user/editor-store',
    data: {..._.pick(query, ['itemId', 'id']), checksum: publicTemplate && publicTemplate.checksum ? publicTemplate.checksum : undefined, 'cl-allow-cache-magic-string': true},
  }).then((response) => {
    _.defer(() => {
      if (_.isFunction(callback)) {
        if (publicTemplate) {
          callback(updateStoreData(response));
        } else {
          callback(response);
        }
      }
    });
  });
};
export const getInitialStore = wrapAjax(getInitialStoreInternal);

export function prefetchAllPublicTemplates() {
  const {templateList} = store.getState().templates;
  async.eachLimit(_.keys(templateList), 5, (id, callback) => {
    getInitialStoreInternal({id}, () => {
      callback();
    });
  });
}
